var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"ldr",attrs:{"role":"status","aria-label":"Loading"}},[_c('div',{staticClass:"ldr__ring"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }